import { render, staticRenderFns } from "./activeList.vue?vue&type=template&id=8fa4546c"
import script from "./activeList.vue?vue&type=script&lang=js"
export * from "./activeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports